import { slideBnr, slideBrandHero, slideMenu, slideMenuOthers, slideNews } from './modules/slideConfig';

slideMenu();
slideNews();
slideBnr();
slideBrandHero();
slideMenuOthers('.js-slideMenuFoodCoatA');
slideMenuOthers('.js-slideMenuFoodCoatB');
slideMenuOthers('.js-slideMenuAbroad');
